import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { TableDataResponse } from 'types/Table';
import {
  ITransaction,
  IBaseTransmissionAct,
  ITransmissionAct,
} from 'types/income';
import { exportXlsxConfig, getSorting } from 'utils/general';
import {
  TransactionsFilters,
  TransmissionActsFilters,
} from './transmission-acts.types';

const getFilters = (filters: Partial<TransmissionActsFilters>) => ({
  page: filters.page,
  pageSize: filters.pageSize,
  ...getSorting(filters.sort),
  filter: {
    companyIds: filters.company ? [filters.company] : undefined,
    dateFrom: filters.date?.from,
    dateTo: filters.date?.to,
  },
});

const getTransactionsFilters = (filters: Partial<TransactionsFilters>) => ({
  filter: {
    companyIds: filters.company ? [filters.company] : undefined,
    dateFrom: filters.date?.from,
    dateTo: filters.date?.to,
  },
});

interface GetTransmissionActs {
  filters: Partial<TransmissionActsFilters>;
}

interface GetTransmissionAct {
  transmissionActId: string;
}

interface GetTransactions {
  filters: Partial<TransactionsFilters>;
}

interface ExportXls {
  params: Partial<{
    transmissionActId: string;
    ongoingBalance: boolean;
    companyId: string;
  }>;
}

export const loaders = {
  getTransmissionActs: ({ filters }: GetTransmissionActs) => {
    return api<TableDataResponse<IBaseTransmissionAct>>({
      url: Endpoints.clientAdmin.transmissionActs.root,
      params: getFilters(filters),
    });
  },
  getTransmissionAct: ({ transmissionActId }: GetTransmissionAct) => {
    return api<ITransmissionAct>({
      url: Endpoints.clientAdmin.transmissionActs.byId.root.replace(
        ':transmissionActId',
        transmissionActId,
      ),
    });
  },
  getTransactions: ({ filters }: GetTransactions) => {
    return api<TableDataResponse<ITransaction>>({
      url: Endpoints.clientAdmin.transmissionActs.balance,
      params: getTransactionsFilters(filters),
    });
  },
  exportXls: ({ params }: ExportXls) => {
    return api({
      url: Endpoints.clientAdmin.transmissionActs.export.xls,
      params,
      ...exportXlsxConfig,
    });
  },
};
